<template>
  <div>
    <UsersDetail :userId="userId" @done="done"></UsersDetail>
  </div>
</template>

<script>
import UsersDetail from 'CORE/components/users/detail'
import { get } from 'lodash'

export default {
    name: 'UsersAdministrationDetailView',
    components: {
        UsersDetail,
    },
    computed: {
        userId() {
            return get(this.$route.params, 'id')
        },
    },
    methods: {
        done() {
            this.$router.push({ name: 'usersList' })
        },
    },
}
</script>
